export default{
    name:'SHRolePicker',
    data() {
        return {
            apis:{//接口地址
                list:'sh/role/list',//角色列表
            },
            roles:[],//角色列表
            checked:[],//已经选中的角色列表
            props:{
                key:'id',
                label:'roleName'
            }
        }
    },
    props:{
        roleKeys:Array,//默认选中的角色主键
    },
    watch: {
        roleKeys(){
            this.initRoleKeys();
        }
    },
    mounted() {
        const me = this;
        me.loadAll();
    },
    methods: {
        loadAll(){
            const me = this;
            me.$post({
                url:me.apis.list,
            }).then(rsp=>{
                me.roles = rsp.retList;
                me.initRoleKeys();
            })
        },
        initRoleKeys(){//初始化已选角色
            const me = this, table = me.$refs['role_table'];
            me.checked = [];
            for(let i in me.roleKeys){
                me.checked.push(me.roleKeys[i]);
                
            }
        },
        getRoles(){
            return this.checked;
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/role/picker/src/picker.js